// Sentry initialization must be imported first
import "./instrument";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import "antd/dist/antd.css";

import "./styles/index.scss";
import App from "./App";
import { store } from "./store";

// import * as serviceWorker from './serviceWorker';

// Tag Sentry events with the logged-in user. auth.user is set by many reducers
// (login, refresh, setAuthUser, logout...), so follow the store instead.
let sentryUserId;
store.subscribe(() => {
  const user = store.getState().auth.user;
  if (user?.id !== sentryUserId) {
    sentryUserId = user?.id;
    Sentry.setUser(user?.id ? { id: user.id } : null);
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <Provider store={store}>
        <App />
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
